import { HasViewModelEventDispatcherInterface, ViewModelEventDispatcherInterface } from "@nts/std/interfaces";
import { Subject } from "rxjs";
import { BehaviorSubject } from "rxjs/internal/BehaviorSubject";

export class ViewModelUtils {

    static isObject(value: unknown): value is Record<string, unknown> {
        return typeof value === 'object' && value !== null;
    }
    static isViewModelEventDispatcher(
        value: unknown
    ): value is ViewModelEventDispatcherInterface {
        if (!this.isObject(value)) {
            return false;
        }

        return (
            value['onActionInProgress'] instanceof BehaviorSubject &&
            value['onWingCollapsed'] instanceof BehaviorSubject &&
            value['onRefreshMessageInViewModel'] instanceof Subject &&
            value['onClearAllMessages'] instanceof Subject &&
            typeof value['onDestroy'] === 'function'
        );
    }

    static hasEventDispatcher(
        obj: unknown
    ): obj is HasViewModelEventDispatcherInterface {
        if (!this.isObject(obj)) {
            return false;
        }

        return this.isViewModelEventDispatcher(obj['eventDispatcher']);
    }
}